export default function ExistingSiteHelp() {
  const scrollToForm = () => {
    const formElement = document.getElementById('landing-page-final-cta');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <section className="py-12 sm:py-20 bg-gradient-to-br from-[#C5A880]/10 to-[#C5A880]/5">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="bg-white rounded-3xl p-6 sm:p-12 md:p-16 text-center border-2 border-[#C5A880] shadow-2xl">
          {/* Icon */}
          <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-[#C5A880] rounded-full mb-6 sm:mb-8 mx-auto">
            <i className="ri-tools-line text-3xl sm:text-4xl text-white"></i>
          </div>

          {/* Header */}
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-4 sm:mb-6 leading-tight font-['Playfair_Display']">
            У вас есть сайт. Но нет результата?
          </h2>

          {/* Description */}
          <p className="text-sm sm:text-xl text-gray-700 mb-4 sm:mb-6 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Не спешите заказывать новый — возможно, вашему текущему сайту просто нужна «терапия смыслов».
          </p>

          <p className="text-sm sm:text-lg text-gray-600 mb-6 sm:mb-10 max-w-3xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Ваш веб-сайт устарел, неудобен, или просто «молчит», несмотря на вложенный бюджет в рекламу? Мы поможем найти слабые места, которые мешают вашим клиентам нажать кнопку «Заказать».
          </p>

          {/* Benefits */}
          <div className="grid sm:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-10 max-w-4xl mx-auto">
            <div className="bg-[#F8F9FA] rounded-2xl p-4 sm:p-6 border border-[#C5A880]/20">
              <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-[#C5A880] rounded-full mb-3 sm:mb-4 mx-auto">
                <i className="ri-search-eye-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display']">
                Экспертный аудит
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 font-['Montserrat'] text-justify">
                Глубокий анализ UX, контента и конверсии
              </p>
            </div>

            <div className="bg-[#F8F9FA] rounded-2xl p-4 sm:p-6 border border-[#C5A880]/20">
              <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-[#C5A880] rounded-full mb-3 sm:mb-4 mx-auto">
                <i className="ri-file-list-3-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display']">
                Пошаговый план
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 font-['Montserrat'] text-justify">
                Конкретные рекомендации по улучшению
              </p>
            </div>

            <div className="bg-[#F8F9FA] rounded-2xl p-4 sm:p-6 border border-[#C5A880]/20">
              <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-[#C5A880] rounded-full mb-3 sm:mb-4 mx-auto">
                <i className="ri-line-chart-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display']">
                Рост конверсии
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 font-['Montserrat'] text-justify">
                Превратите сайт в прибыльную систему
              </p>
            </div>
          </div>

          {/* CTA Button */}
          <button
            onClick={scrollToForm}
            className="inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-[#C5A880] to-[#B39770] hover:from-[#B39770] hover:to-[#A28660] text-white px-6 sm:px-10 py-4 sm:py-5 rounded-full text-sm sm:text-lg font-semibold transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer font-['Montserrat'] w-full sm:w-auto justify-center"
          >
            <i className="ri-flashlight-line text-xl sm:text-2xl"></i>
            Узнайте, как сделать ваш сайт эффективнее!
            <i className="ri-arrow-right-line text-base sm:text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}